export enum FieldSchemaType {
  BOOLEAN = 'BOOLEAN',
  INT_RANGE = 'INT_RANGE',
  ENUM = 'ENUM',
}

export enum FieldDataType {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  ENUM = 'ENUM',
}

export interface FeatureData {
  id: string
  name: string
  fields: Field[]
}

export type FieldRequest<T = undefined> = BooleanFieldRequest<T> | IntRangeFieldRequest<T> | EnumFieldRequest<T>

export interface FeatureRequest<T = undefined> {
  id: string
  name: string
  data: {
    fields: FieldRequest<T>[]
  }
}

export interface FeatureOption {
  label: string
  value: string
}

export type FeatureValue = string | number | boolean

export interface FeatureListItem {
  id: string
  name: string
}

export type Field = BooleanField | IntRangeField | EnumField

export interface BooleanField {
  type: FieldDataType.BOOLEAN
  name: string
  value: boolean | undefined
  required: boolean
}

export type BooleanFieldRequest<T = undefined> = {
  name: string
  type: FieldDataType.BOOLEAN
  value: boolean | T
}

export interface IntRangeField {
  // TODO: this is wrongly named in the API, should be IntRangeConfigField
  name: string
  type: FieldDataType.INTEGER
  required: boolean
  min: number
  max: number
  value: number | null
}

export interface IntRangeFieldRequest<T = undefined> {
  name: string
  type: FieldDataType.INTEGER
  value: number | T
}

export interface EnumField {
  name: string
  type: FieldDataType.ENUM
  value: string | undefined
  required: boolean
  allowedValues: (string | undefined)[]
}

export interface EnumFieldRequest<T = undefined> {
  name: string
  type: FieldDataType.ENUM
  value: string | T
}
